import React from "react";
import {buildNewsImageUrl} from "../utils";

function renderMarks(text, marks = [], key) {
    return marks.reduce((child, mark) => {
        if (mark.type === "bold") return <strong key={key}>{child}</strong>;
        if (mark.type === "italic") return <em key={key}>{child}</em>;
        if (mark.type === "link") {
            return <a key={key} href={mark.attrs?.href} target="_blank" rel="noopener noreferrer">{child}</a>;
        }
        return child;
    }, text);
}

function renderNode(node, idx) {
    if (!node || typeof node.type !== "string") return null;
    const key = idx;

    switch (node.type) {
        case "paragraph":
            return <p key={key}>{(node.content || []).map(renderNode)}</p>;
        case "heading": {
            const level = node.attrs?.level === 3 ? 3 : 2;
            const Tag = `h${level}`;
            return <Tag key={key}>{(node.content || []).map(renderNode)}</Tag>;
        }
        case "bulletList":
            return <ul key={key}>{(node.content || []).map(renderNode)}</ul>;
        case "orderedList":
            return <ol key={key}>{(node.content || []).map(renderNode)}</ol>;
        case "listItem":
            return <li key={key}>{(node.content || []).map(renderNode)}</li>;
        case "image":
            return <img key={key} src={buildNewsImageUrl(node.attrs?.src)} alt={node.attrs?.alt || ""} style={{maxWidth: "100%", borderRadius: 8}}/>;
        case "hardBreak":
            return <br key={key}/>;
        case "text":
            return renderMarks(node.text, node.marks, key);
        default:
            return null;
    }
}

export default function NewsContentRenderer({document}) {
    if (!document || document.type !== "doc" || !Array.isArray(document.content)) return null;
    return <div className="news-content">{document.content.map(renderNode)}</div>;
}
